import React from 'react';
import { DatePicker, Select, Button, Space } from 'antd';
import { ReloadOutlined, SyncOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;
const { Option } = Select;

interface FinanceFiltersProps {
    dateRange: [dayjs.Dayjs, dayjs.Dayjs];
    setDateRange: (dates: [dayjs.Dayjs, dayjs.Dayjs]) => void;
    granularity: 'day' | 'week' | 'month';
    setGranularity: (val: 'day' | 'week' | 'month') => void;
    onRefresh: () => void;
    onRecalculate: () => void;
    recalculating: boolean;
}

export const FinanceFilters: React.FC<FinanceFiltersProps> = ({
    dateRange, setDateRange, granularity, setGranularity, onRefresh, onRecalculate, recalculating
}) => {
    return (
        <div style={{ marginBottom: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h2>财务利润分析</h2>
            <Space>
                <Select value={granularity} onChange={setGranularity} style={{ width: 100 }}>
                    <Option value="day">按日</Option>
                    <Option value="week">按周</Option>
                    <Option value="month">按月</Option>
                </Select>
                <RangePicker
                    value={dateRange}
                    onChange={(dates) => dates && setDateRange(dates as [dayjs.Dayjs, dayjs.Dayjs])}
                    allowClear={false}
                />
                <Button icon={<ReloadOutlined />} onClick={onRefresh}>刷新</Button>
                <Button
                    icon={<SyncOutlined />}
                    onClick={onRecalculate}
                    loading={recalculating}
                >
                    重算利润
                </Button>
            </Space>
        </div>
    );
};
